// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-iy3WfJzY","container":"dp-Y3faGVTW","mobileContainer":"dp-qI112pvk","cardContainer":"dp-ihEX8mq4","icon":"dp-xxVE75fN","title":"dp-jPS9VcNU","desc":"dp-fOzEurVK"};